module.exports = __webpack_public_path__ + "img/privacy-ex-4.930fa831.png";